import { useRef, useState } from 'react'
import './ContactPage.css'

const API = process.env.REACT_APP_API_URL || "";

const INTEREST_TYPES = [
    { value: '', label: 'Select your interest...' },
    { value: 'franchise', label: 'Open a Franchise' },
    { value: 'dealership', label: 'Become a Dealer' },
    { value: 'co-brand', label: 'Co-Branding Partnership' },
    { value: 'investment', label: 'Investment / Funding' },
    { value: 'other', label: 'Other' },
]

const FIELDS = [
    { id: 'name', label: 'Full Name', type: 'text', span: 1 },
    { id: 'phone', label: 'Phone Number', type: 'tel', span: 1 },
    { id: 'email', label: 'Email Address', type: 'email', span: 2 },
    { id: 'company', label: 'Company (Optional)', type: 'text', span: 1 },
    { id: 'city', label: 'City / Location', type: 'text', span: 1 },
    { id: 'interest', label: 'Area of Interest', type: 'select', options: INTEREST_TYPES, span: 2 },
    { id: 'message', label: 'Tell Us More', type: 'area', span: 2 },
]

export default function FranchisePage() {
    const formRef = useRef(null)
    const [focused, setFocused] = useState(null)
    const [values, setValues] = useState({})
    const [fieldErrors, setFieldErrors] = useState({})
    const [generalError, setGeneralError] = useState(null)
    const [sent, setSent] = useState(false)
    const [submitting, setSubmitting] = useState(false)

    const handleChange = (id, val) => {
        setValues(p => ({ ...p, [id]: val }))
        if (fieldErrors[id]) setFieldErrors(p => { const n = { ...p }; delete n[id]; return n })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setSubmitting(true)
        setGeneralError(null)
        try {
            const res = await fetch(`${API}/api/franchise`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(values),
            })
            const data = await res.json()
            if (!res.ok) {
                if (data.errors) setFieldErrors(data.errors)
                else setGeneralError(data.message || 'Submission failed.')
                return
            }
            setSent(true)
            setValues({})
        } catch {
            setGeneralError('Connection error. Please try again.')
        } finally {
            setSubmitting(false)
        }
    }

    return (
        <div className="cp-wrap">
            <div className="cp-hero">
                <div className="cp-hero-grid" />
                <div className="cp-hero-inner">
                    <div className="cp-hero-eyebrow">
                        <span className="cp-hero-dot" style={{ background: '#ea580c' }} />
                        AVIATRICKS · BECOME A DEALER
                    </div>
                    <h1 className="cp-hero-title">
                        Become<br />
                        <em style={{ WebkitTextStrokeColor: '#ea580c' }}>a Dealer.</em>
                    </h1>
                    <p className="cp-hero-sub">
                        Join India's fastest-growing drone ecosystem. Whether you want to open
                        a franchise, become a dealer, or co-brand with us — let's build together.
                    </p>
                </div>
            </div>

            <div className="cp-body">
                <div className="cp-info">
                    <div className="cp-info-label">Partnership Options</div>
                    <div className="cp-info-items">
                        {['Open a Franchise', 'Become a Dealer', 'Co-Branding', 'Investment'].map(item => (
                            <div key={item} className="cp-info-item">
                                <span className="cp-info-item-val">→ {item}</span>
                            </div>
                        ))}
                        <div className="cp-info-item">
                            <span className="cp-info-item-label">Response Time</span>
                            <span className="cp-info-item-val">3 – 5 business days</span>
                        </div>
                        <div className="cp-info-item">
                            <span className="cp-info-item-label">Email</span>
                            <span className="cp-info-item-val">support@aviatricks.in</span>
                        </div>
                    </div>
                </div>

                <div>
                    {!sent ? (
                        <form ref={formRef} className="cp-form" onSubmit={handleSubmit} noValidate>
                            {generalError && <div className="cp-general-error">{generalError}</div>}
                            <div className="cp-grid">
                                {FIELDS.map(f => (
                                    <div key={f.id}
                                        className={`cp-field cp-field--span${f.span} ${focused === f.id || values[f.id] ? 'cp-field--active' : ''}`}
                                    >
                                        <label className="cp-label" htmlFor={f.id}>{f.label}</label>
                                        {f.type === 'area' ? (
                                            <textarea id={f.id} rows={4} className="cp-input" placeholder={f.placeholder}
                                                value={values[f.id] || ''} onFocus={() => setFocused(f.id)} onBlur={() => setFocused(null)}
                                                onChange={e => handleChange(f.id, e.target.value)} />
                                        ) : f.type === 'select' ? (
                                            <select id={f.id} className="cp-select"
                                                value={values[f.id] || ''} onFocus={() => setFocused(f.id)} onBlur={() => setFocused(null)}
                                                onChange={e => handleChange(f.id, e.target.value)}>
                                                {f.options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                            </select>
                                        ) : (
                                            <input id={f.id} type={f.type} className="cp-input" placeholder={f.placeholder}
                                                value={values[f.id] || ''} onFocus={() => setFocused(f.id)} onBlur={() => setFocused(null)}
                                                onChange={e => handleChange(f.id, e.target.value)} />
                                        )}
                                        {fieldErrors[f.id] && <span className="cp-field-error">{fieldErrors[f.id]}</span>}
                                        <div className="cp-field-line" />
                                    </div>
                                ))}
                            </div>
                            <button type="submit" className="cp-submit" disabled={submitting}>
                                <span>{submitting ? 'Submitting...' : 'Send Inquiry'}</span>
                                {!submitting && <span className="cp-submit-arrow">→</span>}
                            </button>
                        </form>
                    ) : (
                        <div className="cp-success">
                            <div className="cp-success-icon">✓</div>
                            <h3>Inquiry Sent.</h3>
                            <p>Check your inbox — we've sent a confirmation email.</p>
                            <p>Our business team will reach out within 3–5 business days.</p>
                            <button onClick={() => setSent(false)} className="cp-retry">Submit Another</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}